import React from 'react';

import styles from './Layout.module.css';

type Props = {
  children?: React.ReactNode[] | React.ReactNode;
};

export const Layout: React.FC<Props> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};
